<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>佛山侧</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">岸侧</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">江侧</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-eb1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEB1, humidityAllowedMaxEB1) }}
              </div>
              <div :class="errorEB1" class="state-info right-pos">
                <p>EB1梁段传感器</p>
                <p>
                  <span>{{ humidityEB1 | toFixed }}% {{ temperatureEB1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ea5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEA5, humidityAllowedMaxEA5) }}
              </div>
              <div :class="errorEA5" class="state-info right-pos">
                <p>EA5梁段传感器</p>
                <p>
                  <span>{{ humidityEA5 | toFixed }}% {{ temperatureEA5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ea2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEA2, humidityAllowedMaxEA2) }}
              </div>
              <div :class="errorEA2" class="state-info right-pos">
                <p>EA2梁段传感器</p>
                <p>
                  <span>{{ humidityEA2 | toFixed }}% {{ temperatureEA2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ea2s">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEA2S, humidityAllowedMaxEA2S) }}
              </div>
              <div :class="errorEA2S" class="state-info right-pos">
                <p>EA2S梁段传感器</p>
                <p>
                  <span>{{ humidityEA2S | toFixed }}% {{ temperatureEA2S | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ea2x">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEA2X, humidityAllowedMaxEA2X) }}
              </div>
              <div :class="errorEA2X" class="state-info left-pos">
                <p>EA2X梁段传感器</p>
                <p>
                  <span>{{ humidityEA2X | toFixed }}% {{ temperatureEA2X | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ej1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEJ1, humidityAllowedMaxEJ1) }}
              </div>
              <div :class="errorEJ1" class="state-info left-pos">
                <p>EJ1梁段传感器</p>
                <p>
                  <span>{{ humidityEJ1 | toFixed }}% {{ temperatureEJ1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ej6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEJ6, humidityAllowedMaxEJ6) }}
              </div>
              <div :class="errorEJ6" class="state-info left-pos">
                <p>EJ6梁段传感器</p>
                <p>
                  <span>{{ humidityEJ6 | toFixed }}% {{ temperatureEJ6 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="clip sensor1 sensor-ej10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEJ10, humidityAllowedMaxEJ10) }}
              </div>
              <div :class="errorEJ10" class="state-info left-pos">
                <p>EJ10梁段传感器</p>
                <p>
                  <span>{{ humidityEJ10 | toFixed }}% {{ temperatureEJ10 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div> -->

          <div class="clip sensor1 sensor-ej14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEJ14, humidityAllowedMaxEJ14) }}
              </div>
              <div :class="errorEJ14" class="state-info left-pos">
                <p>EJ14梁段传感器</p>
                <p>
                  <span>{{ humidityEJ14 | toFixed }}% {{ temperatureEJ14 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-ej18">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorEJ18, humidityAllowedMaxEJ18) }}
              </div>
              <div :class="errorEJ18" class="state-info left-pos">
                <p>EJ18梁段传感器</p>
                <p>
                  <span>{{ humidityEJ18 | toFixed }}% {{ temperatureEJ18 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="clip sensor1 sensor-jh1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJH1, humidityAllowedMaxJH1) }}
              </div>
              <div :class="errorJH1" class="state-info left-pos">
                <p>JH1梁段传感器</p>
                <p>
                  <span>{{ humidityJH1 | toFixed }}% {{ temperatureJH1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div> -->
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>江门侧</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">岸侧</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">江侧</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-wb1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWB1, humidityAllowedMaxWB1) }}
              </div>
              <div :class="errorWB1" class="state-info right-pos">
                <p>WB1梁段传感器</p>
                <p>
                  <span>{{ humidityWB1 | toFixed }}% {{ temperatureWB1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-wa5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWA5, humidityAllowedMaxWA5) }}
              </div>
              <div :class="errorWA5" class="state-info right-pos">
                <p>WA5梁段传感器</p>
                <p>
                  <span>{{ humidityWA5 | toFixed }}% {{ temperatureWA5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-wa2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWA2, humidityAllowedMaxWA2) }}
              </div>
              <div :class="errorWA2" class="state-info right-pos">
                <p>WA2梁段传感器</p>
                <p>
                  <span>{{ humidityWA2 | toFixed }}% {{ temperatureWA2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-w01">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorW01, humidityAllowedMaxW01) }}
              </div>
              <div :class="errorW01" class="state-info left-pos">
                <p>W01梁段传感器</p>
                <p>
                  <span>{{ humidityW01 | toFixed }}% {{ temperatureW01 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-wj1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ1, humidityAllowedMaxWJ1) }}
              </div>
              <div :class="errorWJ1" class="state-info left-pos">
                <p>WJ1梁段传感器</p>
                <p>
                  <span>{{ humidityWJ1 | toFixed }}% {{ temperatureWJ1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-wj6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ6, humidityAllowedMaxWJ6) }}
              </div>
              <div :class="errorWJ6" class="state-info left-pos">
                <p>WJ6梁段传感器</p>
                <p>
                  <span>{{ humidityWJ6 | toFixed }}% {{ temperatureWJ6 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="clip sensor1 sensor-wj10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ10, humidityAllowedMaxWJ10) }}
              </div>
              <div :class="errorWJ10" class="state-info left-pos">
                <p>WJ10梁段传感器</p>
                <p>
                  <span>{{ humidityWJ10 | toFixed }}% {{ temperatureWJ10 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div> -->

          <div class="clip sensor1 sensor-wj14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ14, humidityAllowedMaxWJ14) }}
              </div>
              <div :class="errorWJ14" class="state-info left-pos">
                <p>WJ14梁段传感器</p>
                <p>
                  <span>{{ humidityWJ14 | toFixed }}% {{ temperatureWJ14 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="clip sensor1 sensor-wj18">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ18, humidityAllowedMaxWJ18) }}
              </div>
              <div :class="errorWJ18" class="state-info left-pos">
                <p>WJ18梁段传感器</p>
                <p>
                  <span>{{ humidityWJ18 | toFixed }}% {{ temperatureWJ18 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div> -->

          <div class="clip sensor1 sensor-wb1x">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWB1X, humidityAllowedMaxWB1X) }}
              </div>
              <div :class="errorWB1X" class="state-info left-pos">
                <p>WB1X梁段传感器</p>
                <p>
                  <span>{{ humidityWB1X | toFixed }}% {{ temperatureWB1X | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-wb1s">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWB1S, humidityAllowedMaxWB1S) }}
              </div>
              <div :class="errorWB1S" class="state-info right-pos">
                <p>WB1S梁段传感器</p>
                <p>
                  <span>{{ humidityWB1S | toFixed }}% {{ temperatureWB1S | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="clip sensor1 sensor-wj14x">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ14X, humidityAllowedMaxWJ14X) }}
              </div>
              <div :class="errorWJ14X" class="state-info left-pos">
                <p>WJ14X梁段传感器</p>
                <p>
                  <span>{{ humidityWJ14X | toFixed }}% {{ temperatureWJ14X | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-wj14s">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorWJ14S, humidityAllowedMaxWJ14S) }}
              </div>
              <div :class="errorWJ14S" class="state-info right-pos">
                <p>WJ14S梁段传感器</p>
                <p>
                  <span>{{ humidityWJ14S | toFixed }}% {{ temperatureWJ14S | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humidityEB1: "--",
      humidityEA5: "--",
      humidityEA2: "--",
      humidityEA2S: "--",
      humidityEA2X: "--",
      humidityEJ1: "--",
      humidityEJ6: "--",
      // humidityEJ10: "--",
      humidityEJ14: "--",
      humidityEJ18: "--",
      // humidityJH1: "--",
      temperatureEB1: "--",
      temperatureEA5: "--",
      temperatureEA2: "--",
      temperatureEA2S: "--",
      temperatureEA2X: "--",
      temperatureEJ1: "--",
      temperatureEJ6: "--",
      // temperatureEJ10: "--",
      temperatureEJ14: "--",
      temperatureEJ18: "--",
      // temperatureJH1: "--",

      humidityWB1: "--",
      humidityWA5: "--",
      humidityWA2: "--",
      humidityW01: "--",
      humidityWJ1: "--",
      humidityWJ6: "--",
      // humidityWJ10: "--",
      humidityWJ14: "--",
      // humidityWJ18: "--",
      temperatureWB1: "--",
      temperatureWA5: "--",
      temperatureWA2: "--",
      temperatureW01: "--",
      temperatureWJ1: "--",
      temperatureWJ6: "--",
      // temperatureWJ10: "--",
      temperatureWJ14: "--",
      // temperatureWJ18: "--",

      humidityWB1X: "--",
      humidityWB1S: "--",
      // humidityWJ14X: "--",
      // humidityWJ14S: "--",
      temperatureWB1X: "--",
      temperatureWB1S: "--",
      // temperatureWJ14X: "--",
      // temperatureWJ14S: "--",

      //error
      errorEB1: "--",
      errorEA5: "--",
      errorEA2: "--",
      errorEA2S: "--",
      errorEA2X: "--",
      errorEJ1: "--",
      errorEJ6: "--",
      // errorEJ10: "--",
      errorEJ14: "--",
      errorEJ18: "--",
      // errorJH1: "--",

      errorWB1: "--",
      errorWA5: "--",
      errorWA2: "--",
      errorW01: "--",
      errorWJ1: "--",
      errorWJ6: "--",
      // errorWJ10: "--",
      errorWJ14: "--",
      // errorWJ18: "--",

      errorWB1X: "--",
      errorWB1S: "--",
      // errorWJ14X: "--",
      // errorWJ14S: "--",

      //humidity allowed max
      humidityAllowedMaxEB1: "--",
      humidityAllowedMaxEA5: "--",
      humidityAllowedMaxEA2: "--",
      humidityAllowedMaxEA2S: "--",
      humidityAllowedMaxEA2X: "--",
      humidityAllowedMaxEJ1: "--",
      humidityAllowedMaxEJ6: "--",
      // humidityAllowedMaxEJ10: "--",
      humidityAllowedMaxEJ14: "--",
      humidityAllowedMaxEJ18: "--",
      // humidityAllowedMaxJH1: "--",

      humidityAllowedMaxWB1: "--",
      humidityAllowedMaxWA5: "--",
      humidityAllowedMaxWA2: "--",
      humidityAllowedMaxW01: "--",
      humidityAllowedMaxWJ1: "--",
      humidityAllowedMaxWJ6: "--",
      // humidityAllowedMaxWJ10: "--",
      humidityAllowedMaxWJ14: "--",
      // humidityAllowedMaxWJ18: "--",

      humidityAllowedMaxWB1X: "--",
      humidityAllowedMaxWB1S: "--",
      // humidityAllowedMaxWJ14X: "--",
      // humidityAllowedMaxWJ14S: "--",

      //humidity tooltip error
      humidityTooltipErrorEB1: "--",
      humidityTooltipErrorEA5: "--",
      humidityTooltipErrorEA2: "--",
      humidityTooltipErrorEA2S: "--",
      humidityTooltipErrorEA2X: "--",
      humidityTooltipErrorEJ1: "--",
      humidityTooltipErrorEJ6: "--",
      // humidityTooltipErrorEJ10: "--",
      humidityTooltipErrorEJ14: "--",
      humidityTooltipErrorEJ18: "--",
      // humidityTooltipErrorJH1: "--",

      humidityTooltipErrorWB1: "--",
      humidityTooltipErrorWA5: "--",
      humidityTooltipErrorWA2: "--",
      humidityTooltipErrorW01: "--",
      humidityTooltipErrorWJ1: "--",
      humidityTooltipErrorWJ6: "--",
      // humidityTooltipErrorWJ10: "--",
      humidityTooltipErrorWJ14: "--",
      // humidityTooltipErrorWJ18: "--",

      humidityTooltipErrorWB1X: "--",
      humidityTooltipErrorWB1S: "--",
      // humidityTooltipErrorWJ14X: "--",
      // humidityTooltipErrorWJ14S: "--",

      //humidity, temperature, running -> id
      dataNameIdDict: {
        //humidity, temperature
        humidityEB1: "6a09c236-5607-4191-8af5-ae8be7d6f697",
        humidityEA5: "ad28ef57-06fb-4644-b956-f9f7d7eec46e",
        humidityEA2: "dc895306-dc3a-4efb-b55f-476f09cc56c4",
        humidityEA2S: "08ab04dd-3efa-44bc-ba9b-b6c305ed6bca",
        humidityEA2X: "96c831f4-8e63-430f-9123-ebab1d7492be",
        humidityEJ1: "e52f2acb-3aba-44b5-ad62-fe1a3c10f297",
        humidityEJ6: "d485cb32-0122-4631-bc59-7061e3411c12",
        // humidityEJ10: "--",
        humidityEJ14: "9c7203bc-d40b-44a1-b072-6f9f3385a9fc",
        humidityEJ18: "00fc9195-7981-492d-b560-d606ef43c7a3",
        // humidityJH1: "--",
        temperatureEB1: "f00e8e29-bb99-4928-b7e2-5716f21b1f3b",
        temperatureEA5: "743ca4cb-7a3b-4c19-9036-9fc06e50b40b",
        temperatureEA2: "6f7eed73-8b3a-417e-9605-576df401cfbd",
        temperatureEA2S: "936da1db-bb36-43e5-8388-250f88ae2ff8",
        temperatureEA2X: "341a31f2-33c6-45a7-a5b6-d4a9c502d800",
        temperatureEJ1: "a81c199b-0330-46c6-862d-b7158c7cb78e",
        temperatureEJ6: "1b6b0110-ebb4-4927-b87e-736b93898173",
        // temperatureEJ10: "--",
        temperatureEJ14: "0c188ae8-78a2-4de7-934a-3963db6f4e93",
        temperatureEJ18: "91796fa3-6352-4c4c-9f54-900ccbfaa091",
        // temperatureJH1: "--",

        humidityWB1: "08ee98ac-c14a-4351-bc10-d8fe617ef815",
        humidityWA5: "03176b79-e224-4cd4-9a1f-6cafd8e36b6f",
        humidityWA2: "b3d7e797-67b6-4869-88c0-31af01cc03b6",
        humidityW01: "19d5e5aa-0369-4582-a7fc-88b153161435",
        humidityWJ1: "c32894d1-c8d9-4111-b36d-0b183c2c0006",
        humidityWJ6: "1ab280a3-7748-473e-82d8-df05003337bb",
        // humidityWJ10: "--",
        humidityWJ14: "0d8f4102-2025-4a28-a736-dbda0d2903ca",
        // humidityWJ18: "--",
        temperatureWB1: "37ed8472-66dd-4223-a8be-02e7fbbf5b6e",
        temperatureWA5: "0604168a-51e2-4ee8-9fc0-b0adc7a1d623",
        temperatureWA2: "e0186488-6aad-4141-a618-80eac06081c6",
        temperatureW01: "15bcd14e-f37a-4d38-9612-4e4f5fea56e5",
        temperatureWJ1: "2bb236d1-b61f-4474-9f86-fee25199ba96",
        temperatureWJ6: "1e044649-c072-4ea9-92fa-b77103024363",
        // temperatureWJ10: "--",
        temperatureWJ14: "e33c286f-f72b-4a80-b894-a17f8c9b4917",
        // temperatureWJ18: "--",

        humidityWB1X: "d93ffc7b-b8d3-4759-a3d0-fdc0435fcf1d",
        humidityWB1S: "151fb502-3110-4953-8ad9-c48394a4d0b6",
        // humidityWJ14X: "--",
        // humidityWJ14S: "--",
        temperatureWB1X: "d96b88b7-0b50-4604-bc5d-a9a62a8ac877",
        temperatureWB1S: "6a14129b-a226-4118-8682-739ccf449f2c",
        // temperatureWJ14X: "--",
        // temperatureWJ14S: "--",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxEB1: "6a09c236-5607-4191-8af5-ae8be7d6f697",
        humidityAllowedMaxEA5: "ad28ef57-06fb-4644-b956-f9f7d7eec46e",
        humidityAllowedMaxEA2: "dc895306-dc3a-4efb-b55f-476f09cc56c4",
        humidityAllowedMaxEA2S: "08ab04dd-3efa-44bc-ba9b-b6c305ed6bca",
        humidityAllowedMaxEA2X: "96c831f4-8e63-430f-9123-ebab1d7492be",
        humidityAllowedMaxEJ1: "e52f2acb-3aba-44b5-ad62-fe1a3c10f297",
        humidityAllowedMaxEJ6: "d485cb32-0122-4631-bc59-7061e3411c12",
        // humidityAllowedMaxEJ10: "--",
        humidityAllowedMaxEJ14: "9c7203bc-d40b-44a1-b072-6f9f3385a9fc",
        humidityAllowedMaxEJ18: "00fc9195-7981-492d-b560-d606ef43c7a3",
        // humidityAllowedMaxJH1: "--",

        humidityAllowedMaxWB1: "08ee98ac-c14a-4351-bc10-d8fe617ef815",
        humidityAllowedMaxWA5: "03176b79-e224-4cd4-9a1f-6cafd8e36b6f",
        humidityAllowedMaxWA2: "b3d7e797-67b6-4869-88c0-31af01cc03b6",
        humidityAllowedMaxW01: "19d5e5aa-0369-4582-a7fc-88b153161435",
        humidityAllowedMaxWJ1: "c32894d1-c8d9-4111-b36d-0b183c2c0006",
        humidityAllowedMaxWJ6: "1ab280a3-7748-473e-82d8-df05003337bb",
        // humidityAllowedMaxWJ10: "--",
        humidityAllowedMaxWJ14: "0d8f4102-2025-4a28-a736-dbda0d2903ca",
        // humidityAllowedMaxWJ18: "--",

        humidityAllowedMaxWB1X: "d93ffc7b-b8d3-4759-a3d0-fdc0435fcf1d",
        humidityAllowedMaxWB1S: "151fb502-3110-4953-8ad9-c48394a4d0b6",
        // humidityAllowedMaxWJ14X: "--",
        // humidityAllowedMaxWJ14S: "--",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityEB1: "errorEB1",
        humidityEA5: "errorEA5",
        humidityEA2: "errorEA2",
        humidityEA2S: "errorEA2S",
        humidityEA2X: "errorEA2X",
        humidityEJ1: "errorEJ1",
        humidityEJ6: "errorEJ6",
        // humidityEJ10: "// humidityEJ10",
        humidityEJ14: "errorEJ14",
        humidityEJ18: "errorEJ18",
        // humidityJH1: "// humidityJH1",
        temperatureEB1: "errorEB1",
        temperatureEA5: "errorEA5",
        temperatureEA2: "errorEA2",
        temperatureEA2S: "errorEA2S",
        temperatureEA2X: "errorEA2X",
        temperatureEJ1: "errorEJ1",
        temperatureEJ6: "errorEJ6",
        // temperatureEJ10: "// temperatureEJ10",
        temperatureEJ14: "errorEJ14",
        temperatureEJ18: "errorEJ18",
        // temperatureJH1: "// temperatureJH1",

        humidityWB1: "errorWB1",
        humidityWA5: "errorWA5",
        humidityWA2: "errorWA2",
        humidityW01: "errorW01",
        humidityWJ1: "errorWJ1",
        humidityWJ6: "errorWJ6",
        // humidityWJ10: "// humidityWJ10",
        humidityWJ14: "errorWJ14",
        // humidityWJ18: "// humidityWJ18",
        temperatureWB1: "errorWB1",
        temperatureWA5: "errorWA5",
        temperatureWA2: "errorWA2",
        temperatureW01: "errorW01",
        temperatureWJ1: "errorWJ1",
        temperatureWJ6: "errorWJ6",
        // temperatureWJ10: "// temperatureWJ10",
        temperatureWJ14: "errorWJ14",
        // temperatureWJ18: "// temperatureWJ18",

        humidityWB1X: "errorWB1X",
        humidityWB1S: "errorWB1S",
        // humidityWJ14X: "// humidityWJ14X",
        // humidityWJ14S: "// humidityWJ14S",
        temperatureWB1X: "errorWB1X",
        temperatureWB1S: "errorWB1S",
        // temperatureWJ14X: "// temperatureWJ14X",
        // temperatureWJ14S: "// temperatureWJ14S",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityEB1: "humidityTooltipErrorEB1",
        humidityEA5: "humidityTooltipErrorEA5",
        humidityEA2: "humidityTooltipErrorEA2",
        humidityEA2S: "humidityTooltipErrorEA2S",
        humidityEA2X: "humidityTooltipErrorEA2X",
        humidityEJ1: "humidityTooltipErrorEJ1",
        humidityEJ6: "humidityTooltipErrorEJ6",
        // humidityEJ10: "// humidityEJ10",
        humidityEJ14: "humidityTooltipErrorEJ14",
        humidityEJ18: "humidityTooltipErrorEJ18",
        // humidityJH1: "// humidityJH1",
        humidityWB1: "humidityTooltipErrorWB1",
        humidityWA5: "humidityTooltipErrorWA5",
        humidityWA2: "humidityTooltipErrorWA2",
        humidityW01: "humidityTooltipErrorW01",
        humidityWJ1: "humidityTooltipErrorWJ1",
        humidityWJ6: "humidityTooltipErrorWJ6",
        // humidityWJ10: "// humidityWJ10",
        humidityWJ14: "humidityTooltipErrorWJ14",
        // humidityWJ18: "// humidityWJ18",
        humidityWB1X: "humidityTooltipErrorWB1X",
        humidityWB1S: "humidityTooltipErrorWB1S",
        // humidityWJ14X: "// humidityWJ14X",
        // humidityWJ14S: "// humidityWJ14S",
      },

      // //running -> running tool tip
      dataNameRunningTooltipNameDict: {

      },

      //running -> running class
      dataNameRunningClassNameDict: {

      },
      stationIdList: ["b5fe57c1-e436-46ad-8eba-e6df652209f3"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jiangshun/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-eb1 {
          top: 224px;
          left: 240px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ea5 {
          top: 224px;
          left: 403px;
          &::before {
            bottom: 78px;
            left: -119px;
            width: 170px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 152px;
            left: -91px;
          }
          .state-info {
            right: 105px;
            top: -137px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ea2 {
          top: 224px;
          left: 448px;
          &::before {
            bottom: 112px;
            left: -118px;
            width: 215px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 218px;
            left: -44px;
          }
          .state-info {
            right: 58px;
            top: -202px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ea2x {
          top: 224px;
          left: 448px;
          &::before {
            bottom: -13px;
            left: 01px;
            width: 50px;
            transform: rotate(235deg);
          }
          &::after {
            bottom: -33px;
            left: 40px;
          }
          .state-info {
            right: -155px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ea2s {
          top: 224px;
          left: 448px;
          &::before {
            bottom: -13px;
            left: -35px;
            width: 50px;
            transform: rotate(305deg);
          }
          &::after {
            bottom: -33px;
            left: -39px;
          }
          .state-info {
            right: 56px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ej1 {
          top: 224px;
          left: 543px;
          &::before {
            bottom: 112px;
            left: -80px;
            width: 215px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 217px;
            left: 46px;
          }
          .state-info {
            right: -156px;
            top: -202px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ej6 {
          top: 224px;
          left: 670px;
          &::before {
            bottom: 104px;
            left: -68px;
            width: 205px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 204px;
            left: 60px;
          }
          .state-info {
            right: -170px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ej10 {
          top: 224px;
          left: 775px;
          &::before {
            bottom: 88px;
            left: -46px;
            width: 185px;
            transform: rotate(115deg);
          }
          &::after {
            bottom: 171px;
            left: 85px;
          }
          .state-info {
            right: -195px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ej14 {
          top: 224px;
          left: 879px;
          &::before {
            bottom: 60px;
            left: -28px;
            width: 120px;
            transform: rotate(115deg);
          }
          &::after {
            bottom: 114px;
            left: 56px;
          }
          .state-info {
            right: -168px;
            top: -99px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-ej18 {
          top: 224px;
          left: 985px;
          &::before {
            bottom: 40px;
            left: -10px;
            width: 100px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 75px;
            left: 75px;
          }
          .state-info {
            right: -185px;
            top: -60px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-jh1 {
          top: 224px;
          left: 1115px;
          &::before {
            bottom: 13px;
            left: 0px;
            width: 40px;
            transform: rotate(160deg);
          }
          &::after {
            bottom: 20px;
            left: 38px;
          }
          .state-info {
            right: -145px;
            top: -4px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wb1 {
          top: 224px;
          left: 240px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wa5 {
          top: 224px;
          left: 403px;
          &::before {
            bottom: 78px;
            left: -119px;
            width: 170px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 152px;
            left: -91px;
          }
          .state-info {
            right: 105px;
            top: -137px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wa2 {
          top: 224px;
          left: 448px;
          &::before {
            bottom: 112px;
            left: -118px;
            width: 215px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 218px;
            left: -44px;
          }
          .state-info {
            right: 58px;
            top: -202px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj1 {
          top: 224px;
          left: 543px;
          &::before {
            bottom: 112px;
            left: -80px;
            width: 215px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 217px;
            left: 46px;
          }
          .state-info {
            right: -156px;
            top: -202px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj6 {
          top: 224px;
          left: 670px;
          &::before {
            bottom: 104px;
            left: -68px;
            width: 205px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 204px;
            left: 60px;
          }
          .state-info {
            right: -170px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj10 {
          top: 224px;
          left: 775px;
          &::before {
            bottom: 88px;
            left: -46px;
            width: 185px;
            transform: rotate(115deg);
          }
          &::after {
            bottom: 171px;
            left: 85px;
          }
          .state-info {
            right: -195px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj14 {
          top: 224px;
          left: 879px;
          &::before {
            bottom: 60px;
            left: -28px;
            width: 120px;
            transform: rotate(115deg);
          }
          &::after {
            bottom: 114px;
            left: 56px;
          }
          .state-info {
            right: -168px;
            top: -99px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj18 {
          top: 224px;
          left: 985px;
          &::before {
            bottom: 40px;
            left: -10px;
            width: 100px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 75px;
            left: 75px;
          }
          .state-info {
            right: -185px;
            top: -60px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wb1x {
          top: 224px;
          left: 240px;
          &::before {
            bottom: -13px;
            left: 01px;
            width: 50px;
            transform: rotate(235deg);
          }
          &::after {
            bottom: -33px;
            left: 40px;
          }
          .state-info {
            right: -160px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-w01 {
          top: 224px;
          left: 506px;
          &::before {
            bottom: -13px;
            left: 01px;
            width: 50px;
            transform: rotate(235deg);
          }
          &::after {
            bottom: -33px;
            left: 40px;
          }
          .state-info {
            right: -150px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wb1s {
          top: 224px;
          left: 240px;
          &::before {
            bottom: -13px;
            left: -35px;
            width: 50px;
            transform: rotate(305deg);
          }
          &::after {
            bottom: -33px;
            left: -39px;
          }
          .state-info {
            right: 56px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj14x {
          top: 224px;
          left: 879px;
          &::before {
            bottom: -13px;
            left: 01px;
            width: 50px;
            transform: rotate(235deg);
          }
          &::after {
            bottom: -33px;
            left: 40px;
          }
          .state-info {
            right: -163px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-wj14s {
          top: 224px;
          left: 879px;
          &::before {
            bottom: -13px;
            left: -35px;
            width: 50px;
            transform: rotate(305deg);
          }
          &::after {
            bottom: -33px;
            left: -39px;
          }
          .state-info {
            right: 56px;
            top: 48px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>